import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailCompose from "../pages/Email/email-compose";

// Authentication related pages
// import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import AccessDenied from "../pages/Login/access_denied";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Charts
import ChartsAppex from "../pages/Charts/charts-appex";
import ChartsJs from "../pages/Charts/charts-chartjs";
import ChartsKnob from "../pages/Charts/charts-knob";
import ChartsC3 from "../pages/Charts/charts-c3";
import ChartsSparkLine from "../pages/Charts/charts-sparkline";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import Iconion from "../pages/Icons/Iconion";
import IconFontawesome from "../pages/Icons/IconFontawesome";
import IconThemify from "../pages/Icons/IconThemify";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconTypicons from "../pages/Icons/IconTypicons";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormUpload from "../pages/Forms/FormUpload";
import FormXeditable from "../pages/Forms/FormXeditable";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiBadge from "../pages/Ui/UiBadge";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiPagination from "../pages/Ui/UiPagination";
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline";
import PagesInvoice from "../pages/Extra Pages/pages-invoice";
import PagesDirectory from "../pages/Extra Pages/pages-directory";
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import UiUtilities from "pages/Ui/UiUtilities";
import UiColors from "pages/Ui/UiColors";
import UiOffcanvas from "pages/Ui/UiOffcanvas";
import Chat from "pages/Chat/Chat";
import Kanban from "pages/Kanban";

import Login from "pages/Login/Login";
import EventDashboard from "pages/Event/EventDashboard";
// import SangathanCreate from 'pages/Sangathan/SangathanCreate';
import SangathanList from "pages/Sangathan/SangathanList";
import Event from "pages/Event/Event";
import EventList from "pages/Event/EventList";
import LocationAdd from "pages/Location/LocationAdd";
import LocationList from "pages/Location/LocationList";
import EventUsers from "pages/Event/EventUsers";
import LocationUsers from "pages/Location/LocationUsers";
import UserList from "pages/User/UserList";
import UsersDetails from "pages/User/UsersDetails";
import RegisterEvent from "pages/Event/RegisterEvent";
import EventAttend from "pages/Event/EventAttend";
import RegisterVisitor from "pages/User/RegisterVisitor";
import RequestList from "pages/BenefitRequest/RequestList";
import CategoryList from "pages/EventCategory/CategoryList";
import AddCategory from "pages/EventCategory/AddCategory";
import UsersEdit from "pages/User/UsersEdit";
import ViewCategory from "pages/EventCategory/ViewCategory";
import EditCategory from "pages/EventCategory/EditCategory";
import ManageCategory from "pages/MasterData/Category/CategoryList";
import DesignationList from "pages/MasterData/Designation/DesignationList";
import DepartmentList from "pages/MasterData/Department/DepartmentList";
import ParentSangathan from "pages/Sangathan/ParentSangathanList";
import ChildSangathan from "pages/Sangathan/ChildSangathanList";
import Notification from "pages/Notification/AddNotification";
import NotificationList from "pages/Notification/Notification";
import NewUser from "pages/User/NewUser";
import SangathanMemberList from "pages/Sangathan/SangathanMemberList";
import ParentSangathanMemberList from "pages/Sangathan/ParentSangathansList";
import ChildSangathanMemberList from "pages/Sangathan/ChildSangathanMemberList";
import ViewSangathanMemberList from "pages/Sangathan/ViewSangathanMemberList";
import BusinessApproval from "pages/Business/BusinessApproval";
import ViewBusinessDetails from "pages/Business/ViewDetails";
import ManageMeetings from "pages/meeting/MeetingList";
import NewMeeting from "pages/meeting/NewMeeting";
import ViewMeetingDetails from "pages/meeting/ViewMeetingDetail";
import ScheduleAttendance from "pages/meeting/ScheduleAttendance";
import DynamicFormBuilder from "pages/dynamicform/dynamic_from";
import FormList from "pages/dynamicform/FormList";

const userRoutes = [
  { path: "/dashboard", component: <EventDashboard /> },

  //VUF
  // { path:"/sangathan-create", component: <SangathanCreate /> },
  {
    path: "/sangathan-list",
    component: <SangathanList />,
  },
  {
    path: "/parent-sangathan-list/:parentId",
    component: <ParentSangathan />,
  },
  {
    path: "/parent-sangathan-list/:parentId/child-sangathan-list/:childId",
    component: <ChildSangathan />,
  },

  {
    path: "/sangathan-member-list",
    component: <SangathanMemberList />,
  },
  {
    path: "/parent-sangathans-list/:parentId",
    component: <ParentSangathanMemberList />,
  },
  {
    path: "/parent-sangathans-list/:parentId/child-sangathans-list/:childId",
    component: <ChildSangathanMemberList />,
  },
  {
    path: "/sangathan/view-member-list/:parentId/:type",
    component: <ViewSangathanMemberList />,
  },

  { path: "/Event", component: <Event /> },
  { path: "/Event/:id", component: <Event /> },
  { path: "/EventList", component: <EventList /> },
  { path: "/Event/:id/EventCategoryList", component: <CategoryList /> },
  {
    path: "/Event/:id/EventCategory/add-category",
    component: <AddCategory />,
  },
  {
    path: "/Event/:id/EventCategory/viewCategoryDetails/:categoryid",
    component: <ViewCategory />,
  },
  {
    path: "/Event/:id/EventCategory/edit-category/:categoryid",
    component: <EditCategory />,
  },
  { path: "/LocationAdd", component: <LocationAdd /> },
  { path: "/LocationAdd/:id", component: <LocationAdd /> },
  { path: "/LocationList", component: <LocationList /> },
  { path: "/EventDetails/:id", component: <EventUsers /> },
  { path: "/LocationUsersList/:id", component: <LocationUsers /> },
  { path: "/UserList", component: <UserList /> },
  { path: "/UserDetails/:Type/:id", component: <UsersDetails /> },
  { path: "/UserDetailsEdit/:Type/:id", component: <UsersEdit /> },
  { path: "/RequestList", component: <RequestList /> },
  { path: "/CategoryList", component: <ManageCategory /> },
  { path: "/DesignationList", component: <DesignationList /> },
  { path: "/Meeting", component: <ManageMeetings /> },
  { path: "/NewSchedule", component: <NewMeeting /> },
  { path: "/EditSchedule/:id", component: <NewMeeting /> },
  { path: "/ScheduleDetails/:id", component: <ViewMeetingDetails /> },
  {
    path: "/GetDesignationListByCategory/:cateId",
    component: <DesignationList />,
  },
  { path: "/DepartmentList", component: <DepartmentList /> },
  // //calendar
  { path: "/`calendar`", component: <Calendar /> },

  { path: "/chat", component: <Chat /> },
  { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  // //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  { path: "/apex-charts", component: <ChartsAppex /> },
  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/charts-c3", component: <ChartsC3 /> },
  { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-ion", component: <Iconion /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-themify", component: <IconThemify /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },
  { path: "/tables-editable", component: <EditableTables /> },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-xeditable", component: <FormXeditable /> },
  { path: "/dynamic-form", component: <DynamicFormBuilder /> },
  { path: "/dynamic-form/:id", component: <DynamicFormBuilder /> },
  { path: "/forms-list", component: <FormList /> },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-blank", component: <PagesBlank /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "/create-user",
    component: <NewUser />,
  },
  //for notification
  { path: "/Add", component: <Notification /> },
  { path: "/Notification", component: <NotificationList /> },
  { path: "/business-approval", component: <BusinessApproval /> },
  { path: "/BusinessDetails/:id", component: <ViewBusinessDetails /> },
  { path: "/attendance/:id", component: <scheduleAttendance /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <RegisterVisitor /> },
  { path: "/register/:location", component: <RegisterVisitor /> },
  { path: "/EventRegister/:id", component: <RegisterEvent /> },
  { path: "/EventAttendant/:id", component: <EventAttend /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: "/EventUsers/:id", component: <EventUsers /> },
  { path: "/LocationUsers/:id", component: <LocationUsers /> },
  { path: "/Users", component: <UserList /> },
  { path: "/UsersDetails/:Type/:id", component: <UsersDetails /> },
  { path: "/UserEdit/:Type/:id", component: <UsersEdit /> },
  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/AddNotification", component: <Notification /> },
  { path: "/NotificationList", component: <NotificationList /> },
  { path: "/businessapproval", component: <BusinessApproval /> },
  { path: "/BusinessDetail/:id", component: <ViewBusinessDetails /> },
  { path: "/attendance/:id", component: <ScheduleAttendance /> },
  { path: "/access-denied", component: <AccessDenied /> },
];

export { userRoutes, authRoutes };
